import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IRouter } from '../../../../shared/interfaces/router.interface';
import { IIcon } from '../../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../../shared/components/icon/icons-sizes.enum';
import {
  I2gNgTrackingActionBuilder,
  I2gNgTrackingService,
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../../tracking/tracking.data';
import { NavigationService } from 'i2g-ng-utils';
import { I2gDialogService } from 'i2g-ng-ui';
import { OverdueInvoicesExpandedDialogComponent } from '../overdue-invoices-expanded-dialog/overdue-invoices-expanded-dialog.component';
import { TrackingObjectBuilder } from '../../../../tracking/tracking-object.builder';
import { ReportExpandedViewTypesEnum } from '../../../../report-data/report-data.data';

@Component({
  selector: 'app-insights-metric',
  templateUrl: './insights-metric.component.html',
  styleUrls: ['./insights-metric.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsightsMetricComponent implements OnInit {
  @Input() type: string;
  @Input() label: string;
  @Input() data: string;
  @Input() cta: IRouter;
  @Input() ctaDialog: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingAdditionalProperties: ITrackingProperties;
  @Input() limitedAccessMode: boolean;

  smallLoadingIcon: IIcon;
  mediumLoadingIcon: IIcon;
  largeLoadingIcon: IIcon;
  trackingAction: ITrackingAction;

  constructor(
    private _navigationService: NavigationService,
    private _dialogService: I2gDialogService,
    private _trackingService: I2gNgTrackingService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder
  ) {}

  ngOnInit() {
    const iconName = 'loading-spinner';

    this.smallLoadingIcon = {
      name: iconName,
      size: IconSizesEnum.small,
    };
    this.mediumLoadingIcon = {
      name: iconName,
      size: IconSizesEnum.medium,
    };
    this.largeLoadingIcon = {
      name: iconName,
      size: IconSizesEnum.large,
    };

    this.trackingAction = this._trackingActionBuilder.buildButtonTapped(
      this.type,
      this.trackingScreenName
    );
  }

  handleCta() {
    this._trackingService.trackEvent(
      this.trackingObject,
      this.trackingAction,
      this.trackingAdditionalProperties
    );

    if (this.ctaDialog) {
      const trackingObject = this._trackingObjectBuilder.buildReportExpanded(
        ReportExpandedViewTypesEnum.overdue
      );

      return this._dialogService.openDialog(
        OverdueInvoicesExpandedDialogComponent,
        {
          isDismissible: true,
          disableScrolling: true,
          trackingScreenName: this.trackingScreenName,
          trackingObject,
        }
      );
    }

    if (this.cta) {
      const { route, navigationExtras, disabled } = this.cta;

      if (!disabled) {
        return this._navigationService.goTo(route, navigationExtras);
      }
    }
  }
}
